module.exports = __webpack_public_path__ + "static/media/img3.0dc9023a.png";